import { Modal } from 'antd';
import { Icon } from '../../../../components/icon/icon';
import ButtonIconOutlineMedium from '../../../../components/common/ButtonIconOutline/ButtonIconOutlineMedium';
import './ExampleDesignRecommend.scss';
import { Divider } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { DesignerPageContext } from '../../DesignerPage';
import callApi from '../../../../utils/api/callAPI';
import { Popover } from 'antd';
import { useTranslation } from 'react-i18next';
import { parseJson } from '../../../../utils/string/parseJson';
import { getValueFromString } from '../../../../utils/data/getValue.utils';
import { convertForeignCurrency } from '../../../../utils/currency/currency.utils';

const ExampleDesignRecommend = ({ open, onClose }) => {
  const { currentProduct, fetchDesignLibraryDetail } =
    useContext(DesignerPageContext);
  const [designLibrary, setDesignLibrary] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const [selectedDesignId, setSelectedDesignId] = useState(null);

  const { t } = useTranslation();

  useEffect(() => {
    if (!open) return;

    const fetchDesignLibrary = async () => {
      setLoading(true);
      setErr('');
      try {
        const res = await callApi({
          endpoint: `sale_products/v3/list_sale_products`, // nhớ có slash đầu
          method: 'GET',
          params: {
            limit: 100,
            offset: 0,
            product_id: currentProduct?.id,
          },
        });

        // chuẩn hoá payload
        const payload = res?.data;
        const list =
          payload?.result?.data ?? payload?.data ?? payload?.result ?? [];

        setDesignLibrary(Array.isArray(list) ? list : []);
      } catch (e) {
        setErr(
          e?.data?.error?.message ||
            e?.message ||
            'Không thể tải danh sách phòng'
        );
      } finally {
        setLoading(false);
      }
    };

    fetchDesignLibrary();
  }, [open]);

  const handleSelectDesign = async design => {
    setSelectedDesignId(design.id || design._id);

    // Gọi fetchDesignDetail với ID của design
    if (fetchDesignLibraryDetail && design.id) {
      await fetchDesignLibraryDetail(design.id);
      onClose(); // Đóng modal sau khi load xong
    }
  };

  // Handler khi nhấn nút "Tiếp theo"
  const handleContinue = () => {
    // if (selectedRoomId && onSelectRoom) {
    //   onSelectRoom(selectedRoomId);
    // }
    // onClose?.();
  };

  return (
    <Modal
      title={
        <div className="flex p-24 justify-between items-center self-stretch">
          <span className="text-headline-small">{t('Example designs')}</span>
          <ButtonIconOutlineMedium
            icon={<Icon.ICClose />}
            onClick={() => onClose()}
          />
        </div>
      }
      closable={false}
      classNames={{
        content: '!p-0',
        header: '!m-0',
        body: 'example-design-recommend flex !p-24 justify-start items-start align-center-start gap-16 grow self-stretch flex-wrap overflow-auto',
      }}
      centered
      width={1280}
      open={open}
      onOk={() => {}}
      footer={null}
      onCancel={() => {}}
    >
      {!loading && !err && designLibrary.length === 0 && (
        <div>{t('No example designs available')}</div>
      )}

      {!loading &&
        designLibrary.map(design => (
          <CardExampleDesign
            key={design.id}
            design={design}
            isSelected={selectedDesignId === (design.id || design._id)}
            onSelect={() => handleSelectDesign(design)}
          />
        ))}
    </Modal>
  );
};

export default ExampleDesignRecommend;

const CardExampleDesign = ({ design, isSelected, onSelect }) => {
  if (!design) return null;

  const { t } = useTranslation();
  const { name, description, sizes = {}, price_original, image_urls } = design;

  const formatSize = value => {
    if (value === undefined || value === null || value === 0) return '-';
    return `${value} mm`;
  };

  // Map tên field sang tên hiển thị và thứ tự ưu tiên
  const sizeConfig = {
    // Kitchen fields
    base: { label: t('Kitchen lower'), order: 1 },
    upper: { label: t('Kitchen upper'), order: 2 },
    fullHeight: { label: t('Kitchen ceiling'), order: 3 },
    countertop: { label: t('Countertop'), order: 4 },
    backsplash: { label: t('Backsplash'), order: 5 },
    // Wardrobe fields
    length: { label: t('Length'), order: 1 },
    depth: { label: t('Depth'), order: 2 },
    height: { label: t('Height'), order: 3 },
  };

  const safeSizes =
    sizes && typeof sizes === 'object' && !Array.isArray(sizes) ? sizes : {};

  // Lấy các keys có giá trị từ sizes và sắp xếp theo thứ tự
  const displayDimensions = Object.keys(safeSizes)
    .filter(key => {
      const value = safeSizes[key];
      return value !== undefined && value !== null && value !== 0;
    })
    .sort((a, b) => {
      const orderA = sizeConfig[a]?.order || 999;
      const orderB = sizeConfig[b]?.order || 999;
      return orderA - orderB;
    })
    .map(key => ({
      key,
      label: sizeConfig[key]?.label || key,
      value: sizes[key],
    }));

  return (
    <div
      className={`flex p-12 flex-col items-start gap-12 w-[290px] shadow-dropshadow2 hover:shadow-dropshadow8 border-[2px] border-solid bg-fills-white rounded-[8px] self-stretch ${
        isSelected ? 'border-outline-brand-primary' : 'border-transparent'
      }`}
      onClick={onSelect}
      style={{ cursor: 'pointer' }}
    >
      <div className="h-[260px] flex self-stretch">
        <img
          src={image_urls?.[0] || '/assets/images/kitchen_cabinet.png'}
          alt={name || description}
        />
      </div>

      <span className="text-body-large" style={{ fontWeight: 600 }}>
        {(() => {
          let tempName = getValueFromString(name);
          return (
            <Popover
              getPopupContainer={() => document.body}
              classNames={{
                body: 'py-4 px-6',
              }}
              content={
                <span
                  className="text-label-medium"
                  style={{ color: '#5A5D60' }}
                >
                  {tempName}
                </span>
              }
            >
              <span
                className="text-label-large ellipsis-multiline-1"
                style={{ color: '#5A5D60' }}
              >
                {tempName}
              </span>
            </Popover>
          );
        })()}
      </span>

      <Divider type="horizontal" className="!p-0 m-0" />

      {/* Hiển thị kích thước - chỉ hiển thị nếu có dữ liệu */}
      {displayDimensions.length > 0 && (
        <div className="flex flex-col items-start gap-8 self-stretch">
          {displayDimensions.map(({ key, label, value }) => (
            <div
              key={key}
              className="flex justify-between items-start self-stretch"
            >
              <span className="text-body-medium">{label}</span>
              <span className="text-body-medium">{formatSize(value)}</span>
            </div>
          ))}
        </div>
      )}

      <Divider type="horizontal" className="!p-0 m-0" />

      <span className="text-body-large" style={{ fontWeight: 600 }}>
        {convertForeignCurrency(Number(price_original ?? 0))}
      </span>
    </div>
  );
};

// const CardExampleDesign = ({}) => {
//   return (
//     <div className="flex p-12 flex-col items-start gap-12 card-example-design bg-fills-white rounded-[8px]">
//       <div className="card-example-design-image flex self-stretch">
//         <img src={"/assets/images/kitchen_cabinet.png"} alt="" />
//       </div>
//       <span className="text-body-large" style={{ fontWeight: 600 }}>
//         Tủ bếp TL
//       </span>
//       <Divider type="horizontal" className="!p-0 m-0" />
//       <div className="flex flex-col items-start gap-8 self-stretch">
//         <div className="flex justify-between items-start self-stretch">
//           <span className="text-body-medium">Bếp dưới</span>
//           <span className="text-body-medium">111111</span>
//         </div>
//         <div className="flex justify-between items-start self-stretch">
//           <span className="text-body-medium">Bếp trên</span>
//           <span className="text-body-medium">111111</span>
//         </div>
//         <div className="flex justify-between items-start self-stretch">
//           <span className="text-body-medium">Mặt bếp</span>
//           <span className="text-body-medium">111111</span>
//         </div>
//         <div className="flex justify-between items-start self-stretch">
//           <span className="text-body-medium">Vách bếp</span>
//           <span className="text-body-medium">111111</span>
//         </div>
//       </div>
//       <Divider type="horizontal" className="!p-0 m-0" />
//       <span className="text-body-large" style={{ fontWeight: 600 }}>
//         112,800,00 <span className="text-body-medium">₫</span>
//       </span>
//     </div>
//   );
// };
